import { Flex, Text } from "@aws-amplify/ui-react";
import { MdOutlineFacebook } from "react-icons/md";
import { RxInstagramLogo, RxLinkedinLogo } from "react-icons/rx";
import {
  facebookLink,
  instagramLink,
  linkedInLink,
} from "../../libs/shared/constants";
import PressableExternalLink from "./PressableExternalLink";

export default function SocialChannels() {
  return (
    <Flex justifyContent={"flex-end"} gap={12}>
      <Text>
        <PressableExternalLink url={instagramLink}>
          <RxInstagramLogo size={24} />
        </PressableExternalLink>
      </Text>

      <Text>
        <PressableExternalLink url={facebookLink}>
          <MdOutlineFacebook size={24} />
        </PressableExternalLink>
      </Text>

      <Text>
        <PressableExternalLink url={linkedInLink}>
          <RxLinkedinLogo size={24} />
        </PressableExternalLink>
      </Text>
    </Flex>
  );
}
